// @ts-nocheck
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import constants from "@store/constants";
import { FC } from "react";
import { css } from "styled-components";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import React from "react";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import parse from "html-react-parser";
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import InfoLine from "@store/Library/Components/Toolkit/Icons/Info/InfoLine";

const enum fields {
    disclaimerTitle = "disclaimerTitle",
    disclaimerText = "disclaimerText",
}

export interface FormDisclaimerProps extends WidgetProps {
    fields: {
        [fields.disclaimerTitle]: string;
        [fields.disclaimerText]: string;
    };
}

export interface FormDisclaimerStyles {
    icon?: IconPresentationProps;
    innerWrapper?: InjectableCss;
    textWrapper?: InjectableCss;
    title?: TypographyPresentationProps;
    wrapper?: InjectableCss;
}

const formDisclaimerStyles: FormDisclaimerStyles = {
    wrapper: {
        css: css`
            display: flex;
            gap: ${pxToRem(10)};
        `,
    },
    icon: {
        src: InfoLine,
        color: "inherit",
    },
    title: {
        css: css`
            font-weight: ${x => x.theme.design.typography.weight.bold};
        `,
    },
};

const styles = formDisclaimerStyles;

const FormDisclaimer: FC<FormDisclaimerProps> = ({ fields: { disclaimerTitle, disclaimerText } }) => {
    if (!disclaimerTitle && !disclaimerText) {
        return null;
    }

    return (
        <>
            <StyledWrapper {...styles.wrapper}>
                <Icon {...styles.icon} aria-hidden="true" />
                <StyledWrapper {...styles.innerWrapper}>
                    {disclaimerTitle ? <Typography {...styles.title}>{disclaimerTitle}</Typography> : null}
                    {disclaimerText ? (
                        <StyledWrapper {...styles.textWrapper}>{parse(disclaimerText, parserOptions)}</StyledWrapper>
                    ) : null}
                </StyledWrapper>
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: FormDisclaimer,
    definition: {
        displayName: "Form Disclaimer",
        group: constants.widgetGroup.simpleQuote,
        fieldDefinitions: [
            {
                name: fields.disclaimerTitle,
                displayName: "Disclaimer Title",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Contextual",
            },
            {
                name: fields.disclaimerText,
                displayName: "Disclaimer Text",
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "Contextual",
            },
        ],
    },
};

export default widgetModule;
